<template>
  <div class="attestApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <h2>身份认证</h2>
    <ul class="carduser">
      <li v-for="(item,i) in sfz">
        <div class="left" style="width:90%">
          <p>真实姓名：{{item.name}}</p>
          <p>身份证号：{{item.card}}</p>
        </div>
        <!--<div class="right" @click="getQquey">
          <img src="~assets/images/pyp.png" />
          拍一拍
        </div>-->
      </li>
      <li v-if="sfz.length < 3">
        <div class="left">
          <p>真实姓名：×××××××</p>
          <p>身份证号：请拍摄身份证正面识别</p>
        </div>
        <div class="right" @click="getQquey">
          <img src="~assets/images/pyp.png" />
          拍一拍
        </div>
      </li>
      <li class="last" v-if="lilen <4 && sfz.length < 2" @click="append">添加认证人员</li>
    </ul>
    <h2>手机号验证</h2>
    <ul class="phone">
      <li>
        <div class="left">
          <p>手机号：<input type="text" @input="codeYzm" v-model="phone" placeholder="请输入手机号" /></p>
          <p>验证码：<input type="text" v-model="code" placeholder="请输入验证码" />
            <span @click="send" :style="pat ? 'background:#2F78FF' : ''">{{sendSns}}</span>
          </p>
        </div>
      </li>
    </ul>
    <button @click="save">提交</button>
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        sendSns:'获取验证码',
        userData:[],
        pat:false,
        phone:'',
        code:'',
        sfz:[],
        lilen:0
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
          WeixinJSBridge.call('hideOptionMenu');
      });
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      this.getAttest();
      this.lilen = $('.attestApp .carduser li').length;
      var that = this;
      $('body').on('click','.getQquey',function(){
        that.getQquey()
      })
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getAttest:function(){
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/User/getAttest',
          params:{
            user_id:that.userData.id,
          }
        }).then(function(response){
          that.fullscreenLoading = false;
          var res = response.data.data;
          that.sfz = res;
        }).catch(err=>{
          that.fullscreenLoading = false;
          console.log('请求失败:'+err);
        });
      },

      save:function(){
        var that = this;
        if(that.sfz.length <= 0){
          alert('请先识别身份证正面信息');
          return false;
        }
        if(that.phone == ''){
          alert('请输入手机号码');
          return false;
        }
        if(that.code == ''){
          alert('请输入验证码');
          return false;
        }
        that.axios({
          method:'post',
          url:that.$host+'home/user/saveAttest',
          params:{
            phone:that.phone,
            code:that.code,
            sfz:JSON.stringify(that.sfz),
            user_id:that.userData.id
          }
        }).then(function(response){
          if(response.data.status == 200){
            if(response.data.data == false){
              alert('请添加新的认证人员，避免重复出现！')
            }else{
              that.$router.go(-1);
            }
            
          }else{
            alert(msg.message);
          }
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },

      append:function(){
        var html = '<li>';
          html += '<div class="left">';
          html += '<p>真实姓名：×××××××</p>';
          html += '<p>身份证号：请拍摄身份证正面识别</p>';
          html += '</div>';
          html += '<div class="right getQquey">';
          html += '<img src="http://admin.4008005216.com/upload/20210729/30dc26895570bae482dac64016b9b696.png" />';
          html += '拍一拍';
          html += '</div>';
          html += '</li>';
          $('.attestApp .last').before(html);
          this.lilen = $('.attestApp .carduser li').length;
      },

      getQquey:function(){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'checkJsApi',
              'chooseImage',
              'getLocalImgData'
            ]
          });
          wx.ready(function() {
            wx.checkJsApi({
              jsApiList: ['chooseImage'],
              success: function (res) {
                wx.chooseImage({
                  count: 1,
                  sizeType: ['compressed'],
                  sourceType: ['camera'], 
                  success: function(res) {
                      that.fullscreenLoading = true;
                      var localId = res.localIds[0].toString();
                      wx.getLocalImgData({
                          localId: localId, // 图片的localID
                          success: function(res) {
                            var u = navigator.userAgent;
                            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
                            var s = res.localData;
                            if(isAndroid){
                              s = 'data:image/jpg;base64,'+res.localData
                            }
                              //alert(res.localData.replace('data:image/jpeg/png;base64,',''))
                              that.getAjax(s)
                          }
                      });
                  }
                })
              }
            });
            
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      getAjax:function(localData){
        var that = this;
        $.ajax({
          url:this.$host+'home/user/sfCard',
          method: 'post',
          data:{
            localData:localData
          },
          success:function(msg){
            if(msg.status == 200){
              that.sfz.push({name:msg.data.name,card:msg.data.num});
            }else{
              alert('身份证识别失败！');
            }
            that.fullscreenLoading = false;
          }
        })
      },

      codeYzm:function(){
        let reg = /^1[0-9]{10}$/;
        var phone = this.phone;
        if (reg.test(phone)){
          this.pat = true
        }else{
          this.pat = false
        }
      },
      send:function(){
        if(!this.pat || this.flag){
          return false;
        }
        if(this.phone == ''){
          alert('请输入手机号码');
          return false;
        }
        let reg = /^1[0-9]{10}$/
        if(!reg.test(this.phone)){
          alert('请输入正确的手机号码');
          return false;
        }
        var i = 60
        let time = setInterval(() => {
          i--
          if(i < 1){
            this.sendSns = '获取验证码';
            clearInterval(time)
            this.pat = false;
            this.flag = false
            return false;
          }
          this.sendSns = i+'秒后重试';
          this.flag = true
          }, 1000)

        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/order/SendSms',
          params:{
            phone:that.phone
          }
        }).then(function(response){
          if(response.data.status == 200){
            
          }else{
            alert('短信下发失败');
          }
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .attestApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }
  .attestApp h2{
    width:94%;
    display:block;
    margin:0 auto;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #1B1B20;
    padding:20px 0 15px 0
  }
  .attestApp ul{
    width:94%;
    display:block;
    margin:0 auto;
  }
  .attestApp ul li{
    background:#fff;
    border-radius:8px;
    width:100%;
    padding:5px 0;
    margin-bottom:15px;
  }
  .attestApp ul li:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .attestApp ul li .left{
    float:left;
    width:70%;
    margin-left:5%
  }
  .attestApp ul li .left p{
    font-size: 15px;
    color: #666666;
    height:50px;
    line-height:50px;
    position:relative;
    border-bottom:solid 1px  #EAF1FF
  }
  .attestApp ul li .left p:last-child{
    border-bottom:none;
  }

  .attestApp ul li .right{
    float:left;
    width:25%;
    font-size: 12px;
    color: #999999;
    text-align:center;
    margin-top:30px;
    position:relative;
  }
  .attestApp ul li .right:after{
    content:'';
    width: 1px;
    height: 70px;
    background: #EAF1FF;
    position:absolute;
    left:10px;
    top:-13px
  }
  .attestApp ul li .right img{
    display:block;
    width:28px;
    margin:0 auto;
    margin-bottom:10px;
  }
  .attestApp ul li.last{
    text-align:center;
    color:#2F78FF;
    font-size:16px;
    padding:15px 0;
    font-weight:bold;
    margin-bottom:0px;
  }

  .attestApp .phone li .left{
    float:left;
    width:90%;
    margin-left:5%；
  }
  .attestApp .phone li .left input{
    height:42px;
    width:70%;
    border:none;
    outline:none;
  }
  .attestApp .phone li .left p span{
    position:absolute;
    right:0;
    top:13px;
    height: 25px;
    background: #999;
    border-radius: 25px;
    line-height:26px;
    color:#fff;
    padding:0 10px;
    font-size:12px;
  }
  .attestApp button{
    width:94%;
    display:block;
    margin:0 auto;
    background: #2F78FF;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
    height:45px;
    border:none;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    margin-top:30px;
  }
</style>
